import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateCopyCandidateMutation, MutateCopyCandidateMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'

const document = graphql(/* graphql */`
  mutation mutateCopyCandidate($id: MongoID!, $position: Int!, $distribution: MongoID!, $name: CopyCandidateNameInput!, $details: Boolean, $contact: Boolean, $rates: Boolean, $notes: Boolean, $attachments: Boolean) {
    cat {
      candidate {
        copy (id: $id, position: $position, distribution: $distribution, name: $name, details: $details, contact: $contact, rates: $rates, notes: $notes, attachments: $attachments) {
          recordId
        }
      }
    }
  }
`)

export type UseMutateCopyCandidateReturn = UseMutationResult<
MutateCopyCandidateMutation,
unknown,
MutateCopyCandidateMutationVariables
>

const useMutateCopyCandidate = (): UseMutateCopyCandidateReturn => {
  return useGraphMutation(document)
}

export { useMutateCopyCandidate, document as mutateCopyCandidateDocument }
